import { HttpClient } from '@angular/common/http';
import { Endpoints } from '../../shared/config/endpoints';
import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import DateUtils from 'src/app/utils/date';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.state';

@Injectable({
  providedIn: 'root'
})

export class GeneralTaskService {

  user;
  orgID;
  dateUtil = new DateUtils();
  private _refreshNeeded$ = new Subject<void>();

  get refreshNeeded$() {
    return this._refreshNeeded$;
  }

  private taskapi = this.endpoint.analyticsUrl;
  private signupapi = this.endpoint.signupUrl;
  private dealsapi = this.endpoint.salesServiceUrl;
  private clientapi = this.endpoint.fourFourSixEndpoint;
  private whatsAppApi = this.endpoint.whatsAppUrl;

  constructor(
    private endpoint: Endpoints,
    private http: HttpClient,
    store: Store<AppState>
  ) {
    store.select("userInfo").subscribe((info) => {
      this.orgID = info.organization.id;
      this.user = info.user;
    });
  }

  /**
   * Error Handler
   */
  private handleError = (error: any): Observable<any> => {
    let message = "";
    if (error) {
      if (error.error) {
        message = error.error.message;
      } else {
        message = error.message;
      }
    }
    return of(null);
  };

  //New Flow
  getAssignTasks() {
    const body = {
      clientID: [],
      dealCode: [],
      orgID: `${this.orgID}`,
      status: "",
      type: 2,
      userID: [`${this.user.id}`]
    }
    try {
      return this.http.post(`${this.taskapi}/getTasks`, body).pipe(catchError(this.handleError));
    } catch (e) {
      alert(e);
    };
  }

  getCreatedTasks() {
    const body = {
      clientID: [],
      dealCode: [],
      orgID: `${this.orgID}`,
      status: "",
      type: 1,
      userID: [`${this.user.id}`]
    }
    try {
      return this.http.post(`${this.taskapi}/getTasks`, body).pipe(catchError(this.handleError));
    } catch (e) {
      alert(e);
    };
  }

  /**
  * Add Task
  * @param form
  */
  createTask(form) {
    const tmpDate = form.remindDate;
    let day = tmpDate.getDate();
    day = day < 10 ? `0${day}` : day;
    let month = tmpDate.getMonth() + 1;
    month = month < 10 ? `0${month}` : month;
    const year = tmpDate.getFullYear();
    const date = `${month}-${day}-${year}`;
    const dateTime = `${date} ${form.remindTime}`;
    const remindDate: any = Date.parse(dateTime);
    const body = {
      assigneeID: `${form.assignedUserID}`,
      channel: 'notch',
      clientID: `${form.client.clientId || form.client.id || ""}`,
      clientName: `${form.client.name || ""}`,
      creatorID: `${this.user.id}`,
      dealCode: `${form.deal.code || ""}`,
      dealName: `${form.deal.name || ""}`,
      description: `${form.taskDescription}`,
      dueDate: `${remindDate}`,
      dueTime: remindDate,
      name: `${form.taskName}`,
      orgID: `${this.orgID}`,
      otherID: `${form.client.id || ""}`,
      otherName: `${form.client.type || ""}`,
      status: "PENDING",
    };
    return this.http.post(`${this.taskapi}/addTask`, body).pipe(
      tap(() => {
        this._refreshNeeded$.next();
      })
    );
  }

  commentOnTask(body) {
    try {
      return this.http.post(`${this.taskapi}/addTaskComments`, body).pipe(tap(() => {
        this._refreshNeeded$.next();
      }), catchError(this.handleError));
    } catch (e) {
      alert(e);
    };
  }

  getCommentTask(id) {
    try {
      return this.http.get(`${this.taskapi}/tasks/comments/${id}/${this.orgID}`).pipe(catchError(this.handleError));
    } catch (e) {
      alert(e);
    };
  }

  /**
  * Edit Task
  * @param form
  */
  editGeneralTaskByID(form) {
    const tmpDate = form.remindDate;
    let day = tmpDate.getDate();
    day = day < 10 ? `0${day}` : day;
    let month = tmpDate.getMonth() + 1;
    month = month < 10 ? `0${month}` : month;
    const year = tmpDate.getFullYear();
    const date = `${month}-${day}-${year}`;
    const dateTime = `${date} ${form.remindTime}`;
    const remindDate: any = Date.parse(dateTime);
    const body = {
      assigneeID: `${form.assignedUserID}`,
      channel: `${form.channel}`,
      clientID: `${form.clientID || form.client.clientId || form.client.id || ""}`,
      clientName: `${form.clientName || form.client.name || ""}`,
      completedDate: `${form.completedDate}`,
      createdDate: `${form.createdDate}`,
      creatorID: `${this.user.id}`,
      creatorName: `${form.creatorName}`,
      dealCode: `${form.deal ? form.deal.code : form.dealCode}`,
      dealName: `${form.deal ? form.deal.name : form.dealName}`,
      description: `${form.taskDescription}`,
      dueDate: `${remindDate}`,
      dueTime: remindDate,
      id: form.taskID,
      name: `${form.taskName}`,
      orgID: `${this.orgID}`,
      otherName: `${form.otherName || form.client.type || ""}`,
      otherID: `${form.client ? form.client.id : form.otherID}`,
      section: `${form.section}`,
      status: "PENDING",
      voidedDate: `${form.voidedDate}`
    };
    return this.http.put(`${this.taskapi}/updateTask`, body);
  }

  /**
    * Get Task By ID
    * @param id
    */
  getTaskByID(id) {
    return this.http.get(`${this.taskapi}/getTask/${id}`);
  }

  /**
   * Mark Task As Complete with task id
   * @param id
   */
  markTaskStatus(id, status) {
    const body = {}
    return this.http.put(`${this.taskapi}/changeTaskStatus/${id}/${status}/${this.user.id}`, body);
  }

  /**
   * Whatsapp Number
   * @param form
   */
  integrateWhatsapp(form) {
    const body = {
      whatsappNumber: form.whatsappNumber,
    }
    return this.http.put(`${this.signupapi}/editUserWhatsappNumber/${this.user.id}`, body);
  }

  /**
   * WhatsApp Bot Integration
   * @param form
   */
  integrateWhatsappBot(form) {
    const body = {
      userPhone: form.whatsappNumber,
    }
    return this.http.post(`${this.whatsAppApi}/taskbot/enable/`, body);
  }

  getUsersBySupervisor() {
    return this.http.get(`${this.signupapi}/getAllSupervisorUsers/${this.orgID}/${this.user.email}`);
  }

  /**
   * Get  Filter By USERID AND CLIENTID
   * @param payload
   */
  getFilteredTask(payload) {
    const body = {
      clientID: payload.clientID || [],
      dealCode: payload.dealCode || [],
      orgID: `${this.orgID}`,
      status: payload.status,
      type: payload.type,
      userID: payload.userID || []
    }
    try {
      return this.http.post(`${this.taskapi}/getTasks`, body).pipe(catchError(this.handleError));
    } catch (e) {
      alert(e);
    };
  }

  /**
   * Get Deal Suggestions by form input
   * @param form
   */
  getDealSuggestions(form) {
    return this.http.get(`${this.dealsapi}/${form.inputText}/${this.orgID}/getDealSuggestions`);
  }

  /**
   * CREATE TASK FILTER
   * @param form
   */
  createTaskFilter(form) {
    const payload = {
      clients: [
        {
          clientID: `${form.clientFilter ? form.clientFilter.id : ''}`,
          clientName: `${form.clientFilter ? form.clientFilter.name : ''}`
        }
      ],
      deals: [
        {
          dealCode: `${form.dealFilter ? form.dealFilter.code : ''}`,
          dealName: `${form.dealFilter ? form.dealFilter.name : ''}`
        }
      ],
      name: `${form.name}`,
      orgID: `${this.orgID}`,
      ownerID: `${this.user.id}`,
      status: `${form.statusFilter || ""}`,
      type: parseInt(form.typeFilter),
      userID: [`${form.userFilter ? form.userFilter.id : ''}`]
    };
    return this.http.post(`${this.taskapi}/addTaskCustomFilter`, payload)
  }

  /**
   * Edits filter
   * @param form 
   * @returns  
   */
  editFilter(form) {
    const payload = {
      clients: [
        {
          clientID: `${form.clients ? form.clients.id : ""}`,
          clientName: `${form.clients ? form.clients.name : ""}`
        }
      ],
      deals: [
        {
          dealCode: `${form.deals ? form.deals.code : ""}`,
          dealName: `${form.deals ? form.deals.name : ""}`
        }
      ],
      id: parseInt(form.id),
      name: `${form.name}`,
      orgID: `${this.orgID}`,
      ownerID: `${this.user.id}`,
      status: `${form.status}`,
      type: parseInt(form.type),
      userID: [`${form.userID.id}`]
    }
    return this.http.post(`${this.taskapi}/updateTaskCustomFilter`, payload)
  }

  /**
   * Fetch Result for custom filter task
   * @param id
   */
  getCustomFilterTask(id) {
    try {
      return this.http.get(this.taskapi + `/getFilteredTasks/${id}`).pipe(catchError(this.handleError));
    } catch (e) {
      alert(e);
    };
  }

  /**
   * Get Filtered Task
   * @param id
   */
  getFilteredTasks(id) {
    try {
      return this.http.get(this.taskapi + `/getTaskCustomFilter/${id}`).pipe(catchError(this.handleError));
    } catch (e) {
      alert(e);
    };
  }

  /**
   * Delete Filtered Task
   * @param id
   */
  deleteFilterTask(id) {
    return this.http.delete(`${this.taskapi}/deleteTaskCustomFilter/${id}/`);
  }

  /**
   * Get All Task Filter
   */
  getAllTaskFilter() {
    return this.http.get(`${this.taskapi}/getTaskFilters/${this.user.id}/${this.orgID}`);
  }

  //New Flow ends here
  getAllOrganisationUsers() {
    return this.http.get(`${this.signupapi}/getUsersInOrganization/${this.orgID}`);
  }

  getClientByOrgID() {
    return this.http.get(`${this.clientapi}/clients`);
  }

}
